module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-client-transactions"
  }, [_c('div', {
    staticClass: "action-bar"
  }, [_vm._m(0), _c('div', {
    staticClass: "action"
  }, [_c('transaction-list-form', {
    attrs: {
      "type": 'entity-filter'
    },
    on: {
      "filterTransactions": _vm.filterTransactions
    }
  })], 1)]), _c('div', {
    staticClass: "tabs-inner-content"
  }, [_c('base-list', {
    attrs: {
      "dataLoader": _vm.dataLoader,
      "component": _vm.component,
      "search": _vm.search,
      "componentType": "client-list"
    }
  }, [_c('header-columns', {
    attrs: {
      "slot": "before",
      "columns": _vm.headers
    },
    slot: "before"
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Transactions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b00fa88!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ClientTransactions.vue
// module id = 2305
// module chunks = 1